// extracted by mini-css-extract-plugin
export default {"main":"AppBody_main__xCtZ9"};